module.exports = __webpack_public_path__ + "static/media/jalohomeiset-rypaleet.05c5ce16.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./media/photos/jalohomeiset-rypaleet.jpg
 ** module id = 299
 ** module chunks = 0
 **/